import { render } from "./ProductVariants.vue?vue&type=template&id=6c1b80ab&scoped=true"
import script from "./ProductVariants.vue?vue&type=script&lang=js"
export * from "./ProductVariants.vue?vue&type=script&lang=js"

import "./ProductVariants.vue?vue&type=style&index=0&id=6c1b80ab&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1b80ab"]])

export default __exports__